/** @format */
import { MarketLanguage } from '@mpb-com/feather/enums';

import { TRUSTPILOT_TEMPLATE_IDS } from '@toucan/client/global/trustpilot';

/**
 * The default style for the trustpilot width is to centre the text
 * and we cant override this.
 * As we want the widget to be left aligned, we need to shift it left
 * a certain amount (depending on language), in order to achieve this.
 *
 */
const TrustPilotMarginForTemplateMap = {
    [TRUSTPILOT_TEMPLATE_IDS.microCombo]: {
        [MarketLanguage.FR]: '-5.2rem',
        [MarketLanguage.DE]: '-0.3rem',
        [MarketLanguage.NL]: '-3.6rem',
        [MarketLanguage.IT]: '-3rem',
        [MarketLanguage.EN]: '-4.2rem',
        [MarketLanguage.ES]: '-3.2rem',
        [MarketLanguage.PT]: '-3.6rem',
    },
    [TRUSTPILOT_TEMPLATE_IDS.microStar]: {
        [MarketLanguage.FR]: '-11.7rem',
        [MarketLanguage.DE]: '-10rem',
        [MarketLanguage.NL]: '-11rem',
        [MarketLanguage.IT]: '-11.2rem',
        [MarketLanguage.EN]: '-11.7rem',
        [MarketLanguage.ES]: '-11.4rem',
        [MarketLanguage.PT]: '-11.4rem',
    },
};

export function getTrustpilotDesktopMarginLeft(
    marketLanguage: MarketLanguage,
    isLeftAligned: boolean,
    templateId: string
): string {
    if (!isLeftAligned) {
        return 'initial';
    }

    return (
        TrustPilotMarginForTemplateMap[templateId]?.[marketLanguage] ??
        'initial'
    );
}
